// Do not change it to 'sweetalert2'. We don't want CSS to be imported.
// Correct type is handled by type-only import below.
import Swal from 'sweetalert2/dist/sweetalert2.js'
import type Sweetalert2 from 'sweetalert2'
import type { SweetAlertIcon, SweetAlertResult } from 'sweetalert2'

import { useI18n } from 'vue-i18n-composable'

type SweetAlert2 = typeof Sweetalert2

const useSweetAlert = () => {
    const i18n = useI18n()

    const alert = Swal.mixin({
        buttonsStyling: false,
        customClass: {
            confirmButton: 'v-btn v-btn--contained theme--dark v-size--default',
            cancelButton: 'v-btn v-btn--contained theme--dark v-size--default'
        },
        showCancelButton: true,
        showConfirmButton: true
    }) as SweetAlert2

    const dangerAlert = alert.mixin({
        focusCancel: true,
        icon: 'warning'
    })

    const toast = Swal.mixin({
        position: 'top-end',
        showConfirmButton: false,
        timer: 3500,
        timerProgressBar: true,
        toast: true,
        width: 480,
        didOpen: (toast: HTMLElement): void => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const showDangerAlert = (
        titleText?: string,
        text = i18n.t('alerts.info.irreversible-operation').toString(),
        confirmButtonText = i18n.t('crud.yes').toString(),
        cancelButtonText = i18n.t('crud.cancel').toString()
    ): Promise<SweetAlertResult> => {
        return dangerAlert.fire({
            titleText,
            text,
            confirmButtonText,
            cancelButtonText
        })
    }

    const showToast = (content?: string, icon: SweetAlertIcon = 'success', asHtml = false): Promise<SweetAlertResult> => {
        return toast.fire({
            icon,
            [asHtml ? 'title' : 'titleText']: content
        })
    }

    return {
        alert,
        dangerAlert,
        toast,
        showDangerAlert,
        showToast
    }
}

export {
    useSweetAlert
}
